var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-view',{attrs:{"styles":"flex-5 t-f3 rotate-90"}},[_c('b-text',{staticClass:"ani-notic-part1",attrs:{"styles":"w-3px h-3px bg-color-blue round"}}),_vm._v(" "),_c('b-text',{staticClass:"ani-notic-part2",attrs:{"styles":"w-1.3 h-3px mrg-l-4px bg-color-blue round-sm"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85efbd0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/core/anis/ani-notic.vue
// module id = null
// module chunks = 